exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3sWHV{padding:0!important;border:none!important}._39kc5{padding:5px 10px;line-height:20px;min-height:30px}._3EzJC{font-weight:700;background-color:#f0f0f0}", ""]);

// exports
exports.locals = {
	"tdClear": "_3sWHV",
	"field": "_39kc5",
	"totalField": "_3EzJC"
};